import React from "react";
import { Stack, Text, VStack } from "@chakra-ui/react";
import { CarIcon } from "../../icons/CarIcon";
import { TabletIcon } from "../../icons/TabletIcon";
import { LegalIcon } from "../../icons/LegalIcon";
import { SmilyFaceIcon } from "../../icons/SmilyFaceIcon";
import { PersonalizedIcon } from "../../icons/PersonalizedIcon";
import { FlexibleIcon } from "../../icons/FlexibleIcon";
import { AboutItem } from "./AboutItem";

export const About = () => {
  const items1 = [
    {
      title: "Simple",
      description:
        "Solicitá un viaje en solo 2 pasos. Ingresá desde dónde salís y hacia dónde vas y empezá tu recorrido.",
      icon: <CarIcon color="primary.200" h={5} w={5} />,
    },
    {
      title: "Práctico",
      description:
        "Solicitá un viaje por la app para ver el recorrido de tu conductor o pedilo por Whatsapp y recibí notificiaciones.",
      icon: <TabletIcon color="primary.200" h={5} w={5} />,
    },
    {
      title: "Legal",
      description:
        "Viajá Ya está habilitado para circular. Subí a un auto y no te preocupes por controles municipales o por viajar a zonas populares.",
      icon: <LegalIcon color="primary.200" h={5} w={5} />,
    },
  ];
  const items2 = [
    {
      title: "Cómodo",
      description:
        "Viajá al instante, reservá un viaje o solicitá un servicio de cadetería, ViajáYa se adapta a tus necesidades de cada día.",
      icon: <SmilyFaceIcon color="primary.200" h={5} w={5} />,
    },
    {
      title: "Personalizado",
      description:
        "Viajá con tu mascota, con otras personas, con ambiente climatizado o elegí las comodidades que estés buscando.",
      icon: <PersonalizedIcon color="primary.200" h={5} w={5} />,
    },
    {
      title: "Flexible",
      description:
        "Efectivo o tarjeta de crédito y débito, elegí el medio de pago que más te convenga y viajá ya, seguro y legal.",
      icon: <FlexibleIcon color="primary.200" h={5} w={5} />,
    },
  ];
  return (
    <VStack
      bgColor="primary.900"
      rounded="xl"
      w="80%"
      gap={0}
      p={10}
      zIndex={[9,9,9999]}
      mt={"180px"}
      justifyContent="center"
      alignItems="center"
      id="about"
    >
      <Text
        bgColor="primary.700"
        size="xs"
        color="white"
        rounded='md'
        fontSize="small"
        fontWeight='semibold'
        py={2}
        px={4}
        userSelect='none'
      >
        Quiero viajar
      </Text>
      <Text lineHeight="unset" textAlign={"center"} fontSize="32px" my={10} fontWeight="bold" color='#fff'>
        Tu viaje sin complicaciones
      </Text>
      <Stack
        flexDirection={["column", "column", "row"]}
        w="full"
        justifyContent={['center', 'center', "space-between"]}
        alignItems="flex-start"
        gap={4}
        mb={10}
      >
        {items1.map((item, index) => (
          <AboutItem index={index} item={item} />
        ))}
      </Stack>
      <Stack
        flexDirection={["column", "column", "row"]}
        w="full"
        justifyContent={['center', 'center',"space-between"]}
        alignItems="flex-start"
        gap={4}
      >
        {items2.map((item, index) => (
          <AboutItem index={index} item={item} />
        ))}
      </Stack>
    </VStack>
  );
};
